export const environment = {
  production: true,
  apiUrl: (window as any)['env']['apiUrl'] || '/api/v1',
  /**
   * Preview catalogue switch, read at runtime from assets/env.js exactly like
   * apiUrl. env.js.template does not define it, so a real deployment always
   * gets false and talks to the API. A preview host can opt in by serving an
   * env.js with useMockData: true, without needing a separate build.
   */
  useMockData: (window as any)['env']['useMockData'] === true,
  /**
   * Lets /admin render without a signed-in admin. Read the same way as the
   * two above, and absent from env.js.template for the same reason - a real
   * deployment is always false.
   *
   * It is deliberately narrow: it decides whether the page renders, not what
   * the page can read. The figures come from /api/v1/admin/**, which answers
   * 403 to anyone without ROLE_ADMIN, so even switched on in the wrong place
   * it shows an empty dashboard rather than anybody's orders.
   */
  adminPreview: (window as any)['env']['adminPreview'] === true,

  /**
   * Cloudflare Turnstile site key, read at runtime from assets/env.js like
   * apiUrl, so one build serves every environment.
   *
   * This is the PUBLIC half of the pair - it is visible in the page source by
   * design. The secret half belongs in the backend's TURNSTILE_SECRET_KEY
   * environment variable and must never be added to env.js, which is served to
   * the browser.
   */
  // A value still reading '${...}' was never substituted: treated as unset.
  turnstileSiteKey: /^\$\{/.test((window as any)['env']['turnstileSiteKey'] || '')
    ? '' : ((window as any)['env']['turnstileSiteKey'] || '')
};
